import { useContext } from "react";

import { Colors } from "@blueprintjs/core";
import { useLocation } from "react-router";

import { Flex } from "@/components/layout/flexbox";
import { PageSizeContext } from "@/components/layout/PageSize";
import { ChatLoader } from "@/components/pieces/chat/ChatLoader";
import { STANDARD_NAV_HEIGHT } from "@/css/constants";
import {
  DirectMessageUser,
  ReviewChatUser,
  WorkspaceMeetingUser,
} from "@/types/users";

import { ChatHeader } from "./ChatHeader";
import { MessageGate } from "./MessageGate";
import { SectionContainer } from "./SectionContainer";
import { HEADER_HEIGHT } from "./StyledContainers";

interface ChatSectionProps {
  channelName?: React.ReactNode;
  loading: boolean;
  backLinkTo?: string;
  user?: DirectMessageUser | WorkspaceMeetingUser | ReviewChatUser | null;
  canChat: boolean;
  ChatComponent: React.ComponentType<{ height: number }>;
}

export function ChatSection({
  channelName,
  loading,
  ChatComponent,
  backLinkTo,
  user,
  canChat,
}: ChatSectionProps) {
  const { windowHeight = 0 } = useContext(PageSizeContext);
  const location = useLocation();

  const heightOffset = location.pathname.startsWith("/client")
    ? HEADER_HEIGHT * 2
    : HEADER_HEIGHT;

  return (
    <SectionContainer
      header={
        <Flex
          height={HEADER_HEIGHT}
          alignItems="center"
          justifyContent="space-between"
          style={{ backgroundColor: Colors.WHITE }}
          className="bbs brs"
          px={3}
        >
          <ChatHeader
            loading={loading}
            backLinkTo={backLinkTo}
            user={user}
            channelName={channelName}
          />
        </Flex>
      }
      headerHeight={HEADER_HEIGHT}
      flex={1}
    >
      {canChat && !loading ? (
        <ChatComponent
          height={windowHeight - STANDARD_NAV_HEIGHT - heightOffset}
        />
      ) : canChat && loading ? (
        <ChatLoader />
      ) : (
        <MessageGate />
      )}
    </SectionContainer>
  );
}
